import {ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, ViewEncapsulation} from '@angular/core';
import {WindowService} from '../window.service';

@Component({
  selector: 'app-window-manager',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowManagerComponent {

  windows = [];

  constructor(private windowService: WindowService,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone,
  ) {

    this.windowService.windows$.subscribe((windows) => {

      this.ngZone.run(() => {
        this.windows = windows;
        this.cdr.markForCheck();
      });
    });
  }


}



